import { render, staticRenderFns } from "./EmployeesHeader.vue?vue&type=template&id=4df1dd76&scoped=true"
import script from "./EmployeesHeader.vue?vue&type=script&lang=js"
export * from "./EmployeesHeader.vue?vue&type=script&lang=js"
import style0 from "./EmployeesHeader.vue?vue&type=style&index=0&id=4df1dd76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df1dd76",
  null
  
)

export default component.exports